import { HorizontalLinkList } from '@doda/io-react/pc';
import { RULES } from '../../constants';

export const UpperRightContent: React.FC = () => {
  return <HorizontalLinkList linkList={RULES} />;
};
